"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFile = exports.uploadFile = exports.createLog = exports.AutoLogOutEndpoint = exports.updatePermissions = exports.updateSite = exports.updateGroup = exports.readAllPermissions = exports.readOriginalPermissions = exports.readPOAlertAccess = exports.readPermissions = exports.changePassword = exports.remove = exports.save = exports.groups = exports.list = exports.loaduserprovider = exports.checkLoginValid = exports.sessionKey = exports.current = exports.create = exports.resetPassword = exports.forgotPassword = exports.loginByPortalToken = exports.login_no_session = exports.login = exports.signup = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
/* Auth */
exports.signup = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.NONE,
    method: "post",
    path: "user/signup"
});
exports.login = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.NONE,
    method: "post",
    path: "user/login"
});
exports.login_no_session = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.NONE,
    method: "post",
    path: "user/login_no_session"
});
exports.loginByPortalToken = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.NONE,
    method: "post",
    path: "user/login_by_portal"
});
exports.forgotPassword = endpoint_1.createEndpoint()({
    method: "post",
    path: "user/forgot-password",
    permissions: permissions_1.PERMISSIONS.NONE
});
exports.resetPassword = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.NONE,
    method: "post",
    path: "user/reset-password"
});
/* CRUD */
exports.create = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_USER_CREATE,
    method: "post",
    path: "user/create"
});
exports.current = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_USER_READ,
    method: "get",
    path: "user/current"
});
exports.sessionKey = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_USER_READ,
    method: "post",
    path: "user/sessionKey"
});
exports.checkLoginValid = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_USER_READ,
    method: "post",
    path: "user/check_login"
});
exports.loaduserprovider = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "get",
    path: "user/loaduserprovider"
});
//C-097 users pagination
// export const list = createEndpoint<never, { users: ISanitizedUser[] }>()({
exports.list = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_USER_READ,
    method: "get",
    path: "user/list",
    query: {
        count: "number.required",
        order: { type: "string.optional", values: ["ASC", "DESC"] },
        search: "string.optional",
        sort: "string.optional",
        start: "number.required"
    }
});
exports.groups = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_USERGROUP_READ,
    method: "get",
    path: "user/groups"
});
exports.save = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_USER_UPDATE,
    method: "put",
    path: "user/save"
});
exports.remove = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_USER_DELETE,
    method: "delete",
    tokens: { id: "number.required" },
    path: "user/delete"
});
exports.changePassword = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "user/change-password"
});
exports.readPermissions = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "get",
    path: "user/read-permissions"
});
//C-036.1 new
exports.readPOAlertAccess = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "get",
    path: "user/po-alertaccess"
});
// pharmacies | View disabled sites (sites list). // E-050 2024-04-30 21:55:15
exports.readOriginalPermissions = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "get",
    path: "user/read-original-permissions"
});
exports.readAllPermissions = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "get",
    path: "user/read-all-permissions",
    query: {
        count: "number.required",
        order: { type: "string.optional", values: ["ASC", "DESC"] },
        sort: "string.optional",
        start: "number.required"
    }
});
exports.updateGroup = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "user/update-group"
});
exports.updateSite = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "user/update-site"
});
exports.updatePermissions = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "user/update-permissions"
});
//E-048.2
exports.AutoLogOutEndpoint = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "user/AutoLogoutTime"
});
exports.createLog = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "user/create-log"
});
exports.uploadFile = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "user/uploadFile",
    formData: true
});
exports.removeFile = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "post",
    path: "user/removeFile",
    tokens: { id: "number.required" }
});



//////////////////
// WEBPACK FOOTER
// ./src/api/user/user-client.ts
// module id = 1001
// module chunks = 0 1 2